import { render, staticRenderFns } from "./effectedInstitutionThreat.vue?vue&type=template&id=a0b6ac2e&scoped=true"
import script from "./effectedInstitutionThreat.vue?vue&type=script&lang=js"
export * from "./effectedInstitutionThreat.vue?vue&type=script&lang=js"
import style0 from "./effectedInstitutionThreat.vue?vue&type=style&index=0&id=a0b6ac2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b6ac2e",
  null
  
)

export default component.exports